import type {
  AnimationConfigWithData,
  AnimationConfigWithPath,
} from 'lottie-web/build/player/lottie_light';
import { CSSProperties, memo, useEffect, useRef } from 'react';
import lottieWeb from 'lottie-web/build/player/lottie_light';

type Props = {
  style: CSSProperties;
  params: Omit<AnimationConfigWithData, 'container'> | Omit<AnimationConfigWithPath, 'container'>;
};
const Lottie = ({ style, params }: Props) => {
  const el = useRef(null);

  useEffect(() => {
    const anime = el.current
      ? lottieWeb.loadAnimation({
          container: el.current,
          ...params,
        })
      : undefined;
    return () => {
      anime?.destroy();
    };
  }, [params]);

  return <div data-testid="lottie-animation" ref={el} style={style} />;
};

export default memo(Lottie);
